// extracted by mini-css-extract-plugin
export default {"editAction":"edit-action_editAction__fYUue"};